// @flow
import styled from "styled-components"

export const Center = styled.div`
  justify-content: center;
  display: flex;
`



// WEBPACK FOOTER //
// ./src/pages/Reservation/ExtendReservation/styled.js